// extracted by mini-css-extract-plugin
export var arrow = "styles-module--arrow--2ab8f";
export var inner = "styles-module--inner--8bfa1";
export var table = "styles-module--table--190f4";
export var toggle = "styles-module--toggle--b355e";
export var togglePadding = "styles-module--togglePadding--0f518";
export var wrapper = "styles-module--wrapper--b1ddf";